export { useInfiniteLoader } from './useInfiniteLoader';
export type {
  FetchParams,
  PageResult,
  UseInfiniteLoaderOptions,
  UseInfiniteLoaderReturn,
} from './types';
